import ReactApexChart from "react-apexcharts";
import React from "react";

const cssColorToRGB = (color) => {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.fillStyle = color;
  return ctx.fillStyle;
};

class SubjectChart extends React.Component {
  constructor(props) {
    super(props);
    let colors = [];
    let customLegendItems = [];
    const chartData = props?.analysisdata?.details?.question_subject_topic_chart || {};
    const series = (chartData.series || []).map((s) => {
      customLegendItems.push(s.name);
      colors.push(cssColorToRGB(s.color));
      return ({
        name: s.name,
        color: s.color,
        // name: "",
        type: s.type || "bar",
        data: (s.data || []).map((d) => {
          return ({
            x: d.name,
            y: d.y,
            fillColor: cssColorToRGB(d.color),
          });
        }),
      })
    });

    this.state = {
      series: series,
      options: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val + "%";
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },

        xaxis: {
          labels: {
            style: {
              fontSize: "8px",
              fontWeight: "bold",
            },
          },
          categories: chartData?.categories||[],
          position: "bottom",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: true,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
        },
        yaxis: {
          title: {
            text: "Time (secs)",
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val + "";
            },
          },
        },
        legend: {
          show: true,
          position: 'top',
          customLegendItems: customLegendItems,
          markers: {
            fillColors: colors,
          },
        },
        // fill: {
        //   type: "solid",
        //   colors: colors
        // },
      },
    };
  }

  render() {
    return (
        <div id="chart">
          <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              height={600}
          />
        </div>
    );
  }
}
export default SubjectChart;
